import { render, staticRenderFns } from "./BrandPreviewCard.vue?vue&type=template&id=b44c86be&"
import script from "./BrandPreviewCard.vue?vue&type=script&lang=js&"
export * from "./BrandPreviewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports